module.exports = __webpack_public_path__ + "static/img/welcoming-pahs-nepal-thumb.de5949f0.jpg";